import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Fragment as _Fragment, withCtx as _withCtx } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-start items-start w-full px-8 py-5" }, [
  /*#__PURE__*/_createElementVNode("h3", { class: "text-[16px] font-bold" }, "Gráfico de acciones B"),
  /*#__PURE__*/_createElementVNode("div", { class: "flex justify-between items-center w-full" })
], -1)
const _hoisted_2 = {
  key: 0,
  class: "flex flex-row w-full p-[3%] justify-between items-center gap-3"
}
const _hoisted_3 = {
  id: "articleB",
  class: "flex w-full"
}
const _hoisted_4 = {
  key: 1,
  class: "flex flex-col w-full items-center justify-center gap-4"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-button-green" }, null, -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "font-medium text-gray-500" }, "Cargando...", -1)
const _hoisted_7 = [
  _hoisted_5,
  _hoisted_6
]

import { computed, ref, watch, onMounted } from "vue";

import { shareholderStore } from "@/stores/shareholder";
import {
  MonthlyInfoBalance,
  MonthlyInfoBalanceData,
  FilterType,
} from "../../services/charts/types";

import { Response } from "./types";

import { ChartService } from "../../services/charts/chartService";
import ChartComponent from "../atoms/ChartComponent.vue";
import ComponentCard from "../atoms/ComponentCard.vue";

import ActionsCount from "../molecules/ActionsCount.vue";


export default /*#__PURE__*/_defineComponent({
  __name: 'ActionsChartSection',
  props: {
  filterType: {
    type: Number || undefined,
    default: 0,
    required: false,
  },
  selectedYr: {
    type: Number || undefined,
    default: undefined,
    required: false,
  },
  activeAcc: {
    type: Number,
    required: true,
  },
},
  setup(__props) {

const props = __props;



const resA = ref<Response<any>>();
const resB = ref<Response<any>>();
const resAnulaB = ref<Response<any>>();

const fetchIsOk = computed(
  () =>
    (resA.value?.success ?? false) ||
    (resB.value?.success ?? false) ||
    (resAnulaB.value?.success ?? false)
);

const filterTypeSelected = computed(() => props.filterType);
const selectedYear = computed(() => props.selectedYr ?? 2023);
const activeAccount = computed(() => props.activeAcc);

const shareholderStr = shareholderStore();
const shareholder = computed(() => shareholderStr.shareholder);
//const shareGroupA = "GROUP_A";
const shareGroupB = "GROUP_B";

const anualInfoData = ref<MonthlyInfoBalance[] | null>(null);
//const monthlyInfoDataA = ref<MonthlyInfoBalance[] | null>(null);
const monthlyInfoDataB = ref<MonthlyInfoBalance[] | null>(null);
const balanceService = new ChartService();

const selectedYearUF = computed(() => {
  let uf = anualInfoDataFiltered.value.find(
    (val) => val.year == selectedYear.value
  );
  return uf?.ufValue;
});

function getYearStartAndEndDates(
  year: number | undefined
): string[] | undefined {
  if (year == undefined) return undefined;
  const startDate = new Date(year, 0, 1).toISOString();
  const now = new Date();
  // Para el año en curso: solo hasta el último día del mes actual (meses cerrados + mes en curso)
  const endDate =
    year === now.getFullYear()
      ? new Date(year, now.getMonth() + 1, 0) // último día del mes actual
      : new Date(year, 11, 31); // año cerrado: hasta 31 dic
  return [startDate, endDate.toISOString()];
}

const datesSelected = ref<string[] | undefined>(
  getYearStartAndEndDates(selectedYear.value)
);
function getStartDate(year: number): string {
  const startDate = new Date(year, 0, 1)
    .toISOString()
    .replace("T", " ")
    .replace("Z", "");
  return startDate;
}
function getEndDate(year: number): string {
  const endDate = new Date(year, 11, 30)
    .toISOString()
    .replace("T", " ")
    .replace("Z", "");
  return endDate;
}
async function getBalances() {
  let startDate = datesSelected.value ? datesSelected.value[0] : undefined;
  let endDate = datesSelected.value ? datesSelected.value[1] : undefined;

  /** 
  const balanceReqA = new MonthlyInfoBalanceData(
    activeAccount.value,
    shareGroupA,
    startDate,
    endDate
  );

  resA.value = await balanceService.getBalance(
    activeAccount.value,
    balanceReqA
  );
  monthlyInfoDataA.value = resA?.value?.data;
**/
  const balanceReqB = new MonthlyInfoBalanceData(
    activeAccount.value,
    shareGroupB,
    startDate,
    endDate
  );

  resB.value = await balanceService.getBalance(
    activeAccount.value,
    balanceReqB
  );
  monthlyInfoDataB.value = resB?.value?.data;

  const balanceReqAnualB = new MonthlyInfoBalanceData(
    activeAccount.value,
    shareGroupB,
    getStartDate(2021),
    getEndDate(new Date().getFullYear())
  );

  resAnulaB.value = await balanceService.getBalance(
    activeAccount.value,
    balanceReqAnualB,
    "consolidated"
  );

  anualInfoData.value = resAnulaB?.value?.data;
}
const anualInfoDataFiltered = computed(() => {
  if (!anualInfoData.value) return [];
  let result = anualInfoData.value.reduce(
    (accumulatorValue: any, currentValue) => {
      if (!accumulatorValue[currentValue.year]) {
        accumulatorValue[currentValue.year] = 0;
      }

      if (currentValue.sharesGroupB != 0) {
        accumulatorValue[currentValue.year] = {
          shared: currentValue.sharesGroupB,
          uf: currentValue.ufValue,
        };
      }

      return accumulatorValue;
    },
    {}
  );

  let typedResult = Object.keys(result).map((year) => {
    return {
      year: parseInt(year),
      sharesGroupB: result[year].shared,
      ufValue: result[year].uf,
    };
  });

  return typedResult;
});

onMounted(() => {
  getBalances();
});

watch([selectedYear, filterTypeSelected, activeAccount], () => {
  datesSelected.value = getYearStartAndEndDates(selectedYear.value);
  getBalances();
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(ComponentCard, { title: "" }, {
    default: _withCtx(() => [
      _createElementVNode("div", null, [
        (_unref(filterTypeSelected) == _unref(FilterType).ByYear)
          ? (_openBlock(), _createBlock(ActionsCount, {
              key: 0,
              shareholders: _unref(shareholder)?.investorNumberB,
              shares: _unref(selectedYearUF)
            }, null, 8, ["shareholders", "shares"]))
          : _createCommentVNode("", true),
        (_unref(filterTypeSelected) == _unref(FilterType).ByConsolidated)
          ? (_openBlock(), _createBlock(ActionsCount, {
              key: 1,
              shareholders: _unref(shareholder)?.investorNumberB
            }, null, 8, ["shareholders"]))
          : _createCommentVNode("", true)
      ]),
      _hoisted_1,
      (
          _unref(activeAccount) != 0 &&
          _unref(fetchIsOk) &&
          monthlyInfoDataB.value &&
          monthlyInfoDataB.value.length > 0 &&
          anualInfoData.value &&
          anualInfoData.value.length > 0
        )
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            (monthlyInfoDataB.value)
              ? (_openBlock(), _createElementBlock("section", _hoisted_2, [
                  _createElementVNode("article", _hoisted_3, [
                    _createVNode(ChartComponent, {
                      "actions-data": 
                _unref(filterTypeSelected) == _unref(FilterType).ByYear
                  ? monthlyInfoDataB.value
                  : _unref(anualInfoDataFiltered)
              ,
                      labeled: true,
                      "show-year": _unref(filterTypeSelected) == _unref(FilterType).ByConsolidated
                    }, null, 8, ["actions-data", "show-year"])
                  ])
                ]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_7))
    ]),
    _: 1
  }))
}
}

})